module.exports = __webpack_public_path__ + "static/oneten-cb7bf3a69625014bc01e6aa3d4a7521d.png";